<style lang="scss">
  #bar {
    height: calc(100% - 40px);
  }
  .time_line {
    display: flex;
    padding-right: 10px;
    justify-content: space-between;
    margin: 10px 40px 0 24px;
    height: 1px;
    background: #999;
    color: #999;
    position: relative;
    span {
      position: absolute;
      top: 5px;
      margin-left: -10px;
      &::before {
        content: '|';
        width: 1px;
        color: #999;
        position: relative;
        top: -20px;
        left: 9px;
      }
    }
  }
</style>

<template>
  <div style="height: 100%;">
    <div id="bar" ref="Bar"></div>
    <div class="time_line">
      <span v-for="h in hours.filter(q => !q.hide)" :key="h.t" :style="{left: h.left}">{{ h.t }}</span>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: "DynBar",
  props: [ 'id', 'barConfig', 'update' ],
  data () {
    return {
      barChart: null,
      showBarNum: 27,
      activeBar: null,
      lastX: null,
      hours: [],
      curZoomStart: null // 点击某个高亮时，区域展示开始的X轴值
    }
  },
  watch: {
    barConfig: {
      handler (v) {
        this.setBar(v)
      }
    },
    update (v) {
      if (v) {
        this.activeBar = null
      }
      else {
        if (!this.activeBar) {
          let arr = this.lastX.split(":")
          this.activeBar = new Date().setHours(...arr, 0) / 1000
          this.curZoomStart = this.barChart.getModel().option.dataZoom[0].startValue // 当前展示区域X轴开始值，和activeBar并非一致
          this.setBar(this.barConfig)
        }
      }
    },
    activeBar (v) {
      if (v) this.$emit('changeShowTime', v - 0)
    }
  },
  methods: {
    getHours () {
      let curStamp = new Date().getTime() / 1000
      let startStamp = new Date().setHours(6, 0, 0, 0) / 1000
      let all = curStamp - startStamp
      let tmp = []
      for (let i = startStamp;i <= curStamp; i += 3600) {
        if (i % 3600 === 0) {
          tmp.push({
            left: (i - startStamp) / all * 100 + '%', t: new Date(i * 1000).toTimeString().slice(0, 5), hide: false
          })
        }
      }
      if (tmp.length > 10) {
        tmp.forEach((e, i) => {
          if (i % 2 === 1) e.hide = true
        })
      }
      this.hours = tmp
    },
    setBar (data) {
      this.getHours()
      let { x, y } = data
      x = x.map(el => new Date(el * 1000).toTimeString().slice(0, 8))
      this.lastX = x[x.length - 1]

      if (!this.barChart) this.barChart = echarts.init(this.$refs.Bar)
      let xL = x.length, zoomStart = 0, zoomEnd = 100
      if (xL) {
        let scale = 1 - this.showBarNum / xL
        zoomStart = scale < 0 ? 0 : scale * 100
        if (this.activeBar && this.curZoomStart) {
          this.curZoomStart++
          let s = this.curZoomStart
          zoomStart = s / xL * 100
          zoomEnd = Math.min(xL, s + this.showBarNum) / xL * 100
        }
      }

      let cvsSet = { // 线条相关配置
        boundaryGap: false, // x y轴起点在一起
        axisLine: { show: false, lineStyle: { color: '#999', type: 'dashed' } },
        splitLine: { show: true, lineStyle: { color: '#e9e9e9', type: 'dashed' } },
        axisTick: { lineStyle: { color: '#fff' } }
      }

      let option = {
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow', label: { show: true } } },
        calculable: true,
        // legend: { data: [ '实时流量' ], itemGap: 5 },
        grid: {
          top: 50, left: 30, right: 40, bottom: 50, containLabel: true
        },
        xAxis: {
            type: 'category', data: x, align: 'center',
            ...cvsSet, nameTextStyle: { color: '#272829' }
          },
        yAxis: [
          {
            type: 'value', name: '单位(人次)', position: 'right', offset: 20,
            // axisLabel: {
            //   formatter: function (a) {
            //     return a + '人'
            //   }
            // },
            ...cvsSet
          }
        ],
        dataZoom: [
          {
            show: true, start: zoomStart, end: zoomEnd, zoomLock: true, height: 40, borderColor: '#fff', bottom: 0,
            dataBackground: {
              lineStyle: { color: '#421EEF', width: 1.5, },
              areaStyle: {
                color: { // 渐变
                  type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                  colorStops: [{ offset: 0, color: '#fff' }, { offset: 1, color: 'rgba(66,30,239,1)' }],
                  global: false
                }
              },
            },
            fillerColor: 'rgba(255,57,115,.2)',
            handleStyle: { color: '#FF3973' },
            handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z',
            textStyle: { color: '#FF3973' }
          },
          // { show: 'inside', start: 20, end: 100 },
          // {
          //     show: true,
          //     yAxisIndex: 0,
          //     filterMode: 'empty',
          //     width: 30,
          //     height: '80%',
          //     showDataShadow: false,
          //     left: '93%'
          // }
        ],
        series: [
          {
            name: '实时流量', type: 'bar', data: y, barWidth: 6,
            itemStyle: {
              normal:{ // 通常情况下：
                color: params => {
                  // click选中的显示红色
                  let arr = params.name.split(":")
                  if (new Date(this.activeBar * 1000).toTimeString().slice(0, 8) === params.name) return '#FF3973'
                  // if (this.activeBar - new Date().setHours(...arr, 0) / 1000 === 0) return '#FF3973'
                  return '#2d2cb6'
                  // 其他显示渐变色
                  // return {
                  //     type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                  //     colorStops: [
                  //       { offset: 0, color: 'rgba(255,57,115,1)' },
                  //       { offset: 1, color: 'rgba(66,30,239,1)' }
                  //     ],
                  //     global: false
                  // }
                }
              },
              emphasis: { // 鼠标悬停时：
                // shadowBlur: 10,
                // shadowOffsetX: 0,
                color: '#FF3973'
              }
            }
          }
        ]
      }
      let BC = this.barChart
      BC.setOption(option)
      BC.off('click') // 绑定之前先off click事件防止 click事件触发多次
      BC.on('click', item => {
        this.activeBar = this.barConfig.x[item.dataIndex]
        this.$emit('clickBar', this.activeBar)
        this.curZoomStart = BC.getModel().option.dataZoom[0].startValue // 当前展示区域X轴开始值，和activeBar并非一致
        // this.curZoomStart-- // 保证当前点击重绘不会向左移动一个
        this.setBar(this.barConfig) // 点击之后赋值activeBar为当前选中值，重新渲染当前为红色
      })
      BC.on('dataZoom', params => { // dataZoom 移动事件
        this.curZoomStart = BC.getModel().option.dataZoom[0].startValue // 当前展示区域X轴开始值，和activeBar并非一致
      })

      let fn = () => {
        if (this.$refs.Bar) BC.resize()
        else window.removeEventListener('resize', fn)
      }
      window.addEventListener('resize', fn)
    }
  }
}
</script>
